export class Deferred<T, E = unknown> {
  promise: Promise<T>;
  resolve: (value: T) => void;
  reject: (reason?: E) => void;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
